import React from 'react';
import {
  Button, Card, CardBody, CardTitle, CardSubtitle, Collapse, Col, Container, Row,
} from 'reactstrap';
import Collapsible from 'react-collapsible';

export default class EpubRezipperInfo extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
    };
  }

  toggle = () => {
    this.setState({ collapse: !this.state.collapse });
  }

  render() {
    return (<div>
      <Button
        color="primary"
        onClick={this.toggle}
        style={{ width: '100%' }}
      >
        {this.state.collapse ? 'Hide' : 'Show'} ePub Rezipper Help
      </Button>
      <Collapse isOpen={this.state.collapse}>
        <Card>
          <CardBody>
            <CardTitle className="text-primary">
              ePub Rezipper Info
            </CardTitle>
            <p>
              The ePub Rezipper is a tool for ePubs created using the Digital Hub.
              After making any local changes to your ePub, upload the content files here.
              Click "Zip and Download" to rezip the ePub.
            </p>
            <Collapsible
              trigger={<span className="docs-collapse-trigger-first">Files <i className="fa fa-angle-down" /></span>}
              triggerOpenedClassName="text-info"
              triggerClassName="text-primary"
            >
              <p>
                  The Rezipper will sort all files into Scribe's designated directories:
                </p>
              <ul>
                <li>
                  <code>
                      OEBPS
                    </code> for content.opf, toc.ncx, .xhtml, and CSS files
                  </li>
                <li>
                  <code>
                      OEBPS/images
                    </code> for all image files
                  </li>
                <li>
                  <code>
                      OEBPS/videos
                    </code> for all video files
                  </li>
                <li>
                  <code>
                      OEBPS/audio
                    </code> for all audio files
                  </li>
                <li>
                  <code>
                      OEBPS/fonts
                    </code> for all font files
                  </li>
              </ul>
              <p>
                  Note:
                </p>
              <ul>
                <li>
                    Do not upload directories (folders).
                  </li>
                <li>
                    It is unnecessary to upload the mimetype or META-INF files. Those will be added automatically.
                  </li>
                <li>
                    If your ePub does not follow this structure and you need help rezipping it, <a href="/wfdw/support.html">contact support</a>.
                  </li>
              </ul>
            </Collapsible>
            <Collapsible
              trigger={<span className="docs-collapse-trigger">ePub File <i className="fa fa-angle-down" /></span>}
              triggerOpenedClassName="text-info"
              triggerClassName="text-primary"
            >
              <p>
                  The ePub will not be stored here or be associated with a project in the Digital Hub. Your downloaded copy is the only copy.
                </p>
              <p>
                  Validate your ePub file after downloading in case you introduced errors while making changes or uploading the files.
                  The ePub Rezipper does not validate files.
                </p>
            </Collapsible>
            <Collapsible
              trigger={<span className="docs-collapse-trigger">Browser Support <i className="fa fa-angle-down" /></span>}
              triggerOpenedClassName="text-info"
              triggerClassName="text-primary"
            >
              <p>
                  The Rezipper supports current versions of most browsers:
                </p>
              <ul>
                <li>
                    Chrome
                  </li>
                <li>
                    Firefox
                  </li>
                <li>
                    Edge
                  </li>
                <li>
                    Internet Explorer
                  </li>
              </ul>
              <p>It does not support Safari.</p>
            </Collapsible>
          </CardBody>
        </Card>
      </Collapse>
    </div>);
  }
}
